import axios from 'axios';
import { API_URL } from '../../../utils/constants';


export const userLoginApi = async (postData) => {
  try {
    postData.type = 2;
    const response = await axios({
      method: 'POST',
      url: `${API_URL}login`,
      data: postData,
      headers: { 'Content-Type': 'application/json', 'Authorization': null },
    });
    if (response.status === 200) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${response?.data?.api_token}`;
      return response.data;
    } else {
      return response.data || response;
    }

  } catch (e) {
    return e;
  }
};
